'use client';
import GloLayout from 'lowcode/common/GloLayout';
import EditorLink from 'lowcode/components/EditorLink';
import styles from './index.module.scss';
import HQuestion from './components';
import { getQuestionList } from '../service';
import { config } from '../config';

export default function Content({ id, data, initIndex = 0, isEditStatus = false }: any) {
    const { titleColor, subTitleColor, themeColor, ruleColor, ruleBgColor, image, mobileImage, loginType } = data;
    const { defaultData } = config;
    const styleOption: any = {
        '--member-question-title': titleColor || defaultData.titleColor,
        '--member-question-subtitle': subTitleColor || defaultData.subTitleColor,
        '--member-question-theme': themeColor || defaultData.themeColor,
        '--member-question-rule': ruleColor || defaultData.ruleColor,
        '--member-question-rulebg': ruleBgColor || defaultData.ruleBgColor,
    };
    return (
        <GloLayout id={id} className={`temp-questions ${styles.content}`}>
            <div style={styleOption}>
                <HQuestion id={data.id} isEditStatus={isEditStatus} background={{ image, mobileImage }} styleOption={styleOption} loginType={loginType} />
            </div>
        </GloLayout>
    );
}
